import type { IStockData } from '@/common/interfaces/stocks.interface';
import type { ICartItemDetail } from '@/common/interfaces/cart.interface';
import type { ISizeOrderCounts } from '@/common/interfaces/store.interface';

export const STOCK_STATUS_ENUM = {
  OUT_OF_STOCK: 'outOfStock',
  LOW_IN_STOCK: 'lowInStock',
  IN_STOCK: 'inStock',
  LOW_AND_OUT_OF_STOCK: 'lowAndOutOfStock',
  STOCK_DATA_UNAVAILABLE: 'stockDataUnavailable',
  MOQ: 'moq',
} as const;

export type StockStatusEnum = (typeof STOCK_STATUS_ENUM)[keyof typeof STOCK_STATUS_ENUM];

export interface ISizeSelectedState {
  label: string;
  selected: boolean;
  disabled: boolean;
  standard?: boolean;
  addedByUser?: boolean;
  /** Size cannot be deselected because the live store already has orders for it. */
  lockedByExistingOrder?: boolean;
}

export interface IStockStatusProps {
  message: string;
  opsApprovalMessage: string;
  showOpsApprovalMessage: boolean;
  status?: StockStatusEnum;
  checkoutMessage?: string;
  backgroundColor?: string;
  borderColor?: string;
  fontColor?: string;
  iconColor?: string;
}

export interface IStocksData {
  color_code?: string;
  stock_data: IStockData[];
  stockDataOnSizes: IStockData[];
  stockProps: IStockStatusProps | null;
  selectedSizesStockInfo: IStockData[];
  isFpExclusiveAndLowOrOutOfStock?: boolean;
}

export interface ISizeFormGroup {
  itemId: string;
  orderItemId: string;
  alphaNumericOrderItemsId: string;
  designGroupName: string;
  sizesAvailable: Record<string, boolean>;
  sizesSelected: Record<string, ISizeSelectedState>;
  stockValid: boolean;
  stockNotes: {
    note: string;
    file: string | null;
  };
  stocks: object | null;
  stocksData: IStocksData | null;
}

export interface IStoreOrderProduct {
  orderItemId: string;
  storeOrderItemId: number;
  order_item_id: string;
  alphaNumericOrderItemsId: string;
  apparelStyleCode: string;
  apparelColorCode: string;
  apparelColorHex: string;
  apparelName: string;
  imageUrl: string;
  /** Size pool codes from design.apparel.sizes. */
  designApparelSizes: string;
  /** Selected sizes from order_item.sizes. */
  orderItemSizes: string;
  /** @deprecated Use designApparelSizes for size pool code mappings. */
  apparelSizes: string;
  isExternalApparel: boolean;
  designGroup: string;
  proofItemId: number;
  cartItemId: number;
  designId: number;
  stocksData?: IStocksData | null;
}

export interface IStoreConfirmSizesProps {
  designGroups: { name: string; items: ICartItemDetail[] }[];
  isReadOnly?: boolean;
  isEditStorePage?: boolean;
  sizeOrderCounts?: ISizeOrderCounts;
  isSalesUser?: boolean;
  mobile?: boolean;
  storeId?: string | number | null;
}

export interface ISizesFormValues {
  sizes: ISizeFormGroup[];
}
